import Constants from 'client/util/Constants';

const { dataNotAvailable } = Constants;

// NumberFormat's first param is locale, JC does not have this user settings AFAIK.
// Also the browser settings taken from `navigator.language(s)` can lead to unexpected results
// like for example `de-DE` (german language) locales results into `204,00 $`
// or `cs` (czech language) locales results into `204,00 US$`
// both seems to me weird, so I pick en-US as the locale.
const getCurrencySign = ({ currency = 'USD', amount }) => (
  new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount)
);

export const invoiceProperties = {
  id: 'id',
  dueDate: 'dueDate',
  status: 'status',
  amountBilled: 'amountBilled',
  amountPaid: 'amountPaid',
  amountRemaining: 'amountRemaining',
  currency: 'currency',
};

export const invoiceMetadata = {
  [invoiceProperties.id]: {
    getDataValue: invoice => invoice[invoiceProperties.id] || dataNotAvailable,
  },
  [invoiceProperties.dueDate]: {
    getDataValue: invoice => invoice[invoiceProperties.dueDate] || dataNotAvailable,
  },
  [invoiceProperties.amountBilled]: {
    getDataValue: invoice => (
      invoice.amountBilled !== undefined
        ? getCurrencySign({ currency: invoice.currency, amount: invoice.amountBilled })
        : dataNotAvailable),
  },
  [invoiceProperties.status]: {
    getDataValue: invoice => invoice[invoiceProperties.status] || dataNotAvailable,
  },
};

export const columnsData = [
  {
    label: 'Due Date',
    dataFieldName: invoiceProperties.dueDate,
  }, {
    label: 'Amount',
    dataFieldName: invoiceProperties.amountBilled,
  }, {
    label: 'Invoice Number',
    dataFieldName: invoiceProperties.id,
  }, {
    label: 'Status',
    dataFieldName: invoiceProperties.status,
  },
];

export default {
  columnsData,
  invoiceProperties,
  invoiceMetadata,
};
